// Modules
import { Fragment, ReactElement } from 'react';

// Web Components
import { BiuDropdown } from '../../biu-web-components/src/components';

// Constants
import { constant } from '../../constants/contant';

// Types
import { Event } from '../../types/events';

import { useHistory } from 'react-router-dom';

const AddToCalendar = ({
	event,
	lang,
}: {
	event: Event;
	lang: string;
}): ReactElement => {
	const history = useHistory();

	const onOptionSelect = (event: any) => {
		window.open(event.detail.url, '_blank')
	};

	// Render
	return (
		<BiuDropdown
			label={constant[lang].VARIABLES.DOWNLOAD_TO_CAL}
			options={event.calEvents}
			onBiuOnOptionSelect={onOptionSelect}
		/>
	);
};

export default AddToCalendar;
